import type { IOffersRequest } from "@commonTypes/offer"

export const offersKeys = {
  all: ["offers"] as const,
  lists: () => [...offersKeys.all, "list"] as const,
  details: () => [...offersKeys.all, "detail"] as const,
  detail: (offer_code: string | undefined) =>
    [...offersKeys.details(), offer_code] as const,
  marketsByZipCode: (zip_code: string | undefined) =>
    [...offersKeys.all, "marketsByZipCode", zip_code] as const,
  dynamicOffers: (params: IOffersRequest | undefined) =>
    [...offersKeys.all, "dynamicOffers", params] as const,
  recentlyViewedOffers: (
    market_code: string | undefined,
    prospect_guid: string | undefined,
  ) =>
    [
      ...offersKeys.all,
      "recentlyViewedOffers",
      market_code,
      prospect_guid,
    ] as const,
  contractTypes: () => [...offersKeys.all, "contractTypes"] as const,
  allPlans: () => [...offersKeys.all, "allPlans"] as const,
  planSOP: () => [...offersKeys.all, "planSOP"] as const,
  planRewards: (plan_code: string | undefined) =>
    [...offersKeys.all, "planRewards", plan_code] as const,
  markets: () => [...offersKeys.all, "markets"] as const,
}
